import React, { useEffect, useState } from 'react';
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Switch from "react-switch";
import Swal from 'sweetalert2';
import axios from 'axios';

const PageContact = () => {
    const [loading, setLoading] = useState(false);
    const [activeOnlineSales, setActiveOnlineSales] = useState(true);
    const [activeTime, setActiveTime] = useState(true);
    const [page_contact_id, setPageContactId] = useState(1);
    const [contact_title, setContactTitle] = useState('');
    const [contact_sub_title, setContactSubTitle] = useState('');
    const [contact_email, setContactEmail] = useState('');
    const [contact_phone, setContactPhone] = useState('');
    const [contact_location, setContactLocation] = useState('');
    const [contact_map, setContactMap] = useState('');
    const [card_1, setCard1] = useState('');
    const [card_2, setCard2] = useState('');
    const [link_fact, setLinkFact] = useState('');
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        window.scrollTo(0, 0);
        getContact();
        getOnlineSalesStatus();
        getTimeStatus();
    }, []);

    const getContact = async () => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-page-contact/' + page_contact_id)
            .then(response => {
                setLoading(false);
                setPageContactId(response.data.data.page_contact_id)
                setContactTitle(response.data.data.contact_title);
                setContactSubTitle(response.data.data.contact_sub_title);
                setContactEmail(response.data.data.contact_email);
                setContactPhone(response.data.data.contact_phone);
                setContactLocation(response.data.data.contact_location);
                setContactMap(response.data.data.contact_map);
                setCard1(response.data.data.card_1);
                setCard2(response.data.data.card_2);
                setLinkFact(response.data.data.link_fact);
            }).catch(function (error) {
                console.log(error)
                setLoading(false);
            });
    }

    const getOnlineSalesStatus = async () => {
        try {
            const response = await axios.get(ENDPOINT + 'get-page-contact/' + page_contact_id);
            setActiveOnlineSales(response.data.data.active_page === 1);
        } catch (error) {
            console.error("Error al obtener el estado de ventas online", error);
        }
    };

    const getTimeStatus = async () => {
        try {
            const response = await axios.get(ENDPOINT + 'get-page-contact/' + page_contact_id);
            setActiveTime(response.data.data.activetime === 1);
        } catch (error) {
            console.error("Error al obtener el estado de horarios", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await axios
            .put(ENDPOINT + "update-page-contact/" + page_contact_id, {
                contact_title: contact_title,
                contact_sub_title: contact_sub_title,
                contact_email: contact_email,
                contact_phone: contact_phone,
                contact_location: contact_location,
                contact_map: contact_map,
                card_1: card_1,
                card_2: card_2,
                link_fact: link_fact,
                active_page: activeOnlineSales ? 1 : 0,
                activetime: activeTime ? 1 : 0
            })
            .then((response) => {
                setLoading(false);
                getContact();
                Swal.fire({
                    icon: "success",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: false,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            })
            .catch(function (error) {
                console.log(error);
                setLoading(true);
                Swal.fire({
                    icon: "error",
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    timer: 3000,
                    html: '<div class="text-custom-alert">' + error.response.data.msg + "</div>",
                    showClass: { popup: "animate__animated animate__fadeInDown" },
                    hideClass: { popup: "animate__animated animate__fadeOutUp" },
                });
            });
    };

    const toggleOnlineSalesStatus = async () => {
        const newStatus = !activeOnlineSales;

        try {
            setLoading(true);

            await axios.put(ENDPOINT + "update-page-contact/" + page_contact_id, {
                contact_title,
                contact_sub_title,
                contact_email,
                contact_phone,
                contact_location,
                contact_map,
                card_1,
                card_2,
                link_fact,
                active_page: newStatus ? 1 : 0,
                activetime: activeTime ? 1 : 0
            });

            setActiveOnlineSales(newStatus);
            setLoading(false);

            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 2000,
                html: `<div class="text-custom-alert">Ventas online ${newStatus ? 'activadas' : 'desactivadas'}</div>`,
            });
        } catch (error) {
            setLoading(false);
            console.error(error);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al actualizar el estado</div>',
            });
        }
    };

    const toggleTimeStatus = async () => {
        const newStatus = !activeTime;

        try {
            setLoading(true);

            await axios.put(ENDPOINT + "update-page-contact/" + page_contact_id, {
                contact_title,
                contact_sub_title,
                contact_email,
                contact_phone,
                contact_location,
                contact_map,
                card_1,
                card_2,
                link_fact,
                active_page: activeOnlineSales ? 1 : 0,
                activetime: newStatus ? 1 : 0
            });

            setActiveTime(newStatus);
            setLoading(false);

            Swal.fire({
                icon: "success",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 2000,
                html: `<div class="text-custom-alert">Ver Filtro en los horarios ${newStatus ? 'activado' : 'desactivado'}</div>`,
            });
        } catch (error) {
            setLoading(false);
            console.error(error);
            Swal.fire({
                icon: "error",
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al actualizar el estado de horarios</div>',
            });
        }
    };

    const handleClose = () => {
        window.history.back();
    }

    return (
        <>
            {loading && <Loader />}
            <div className="page-contact-wrapper">
                <div className="page-contact-container">
                    <ContentHeader title="Administración Página Contacto" />

                    <div className="page-contact-card">
                        <div className="page-contact-header">
                            <h3 className="page-contact-title">
                                <i className="bi bi-envelope-paper me-2"></i>
                                Gestionar Información de Contacto
                            </h3>
                            <p className="page-contact-subtitle">
                                Complete los campos para actualizar la información de contacto
                            </p>
                            <div className="d-flex align-items-center mb-2">
                                <label className="form-label fw-bold me-2 mb-0">Ventas Online:</label>
                                <Switch
                                    onChange={toggleOnlineSalesStatus}
                                    checked={activeOnlineSales}
                                    onColor="#28a745"
                                    offColor="#dc3545"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <label className="form-label fw-bold me-2 mb-0">Ver todos los horarios:</label>
                                <Switch
                                    onChange={toggleTimeStatus}
                                    checked={activeTime}
                                    onColor="#28a745"
                                    offColor="#dc3545"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                />
                            </div>
                        </div>

                        <div className="page-contact-content">
                            <form id="formulario" onSubmit={handleSubmit}>
                                <div className="page-contact-section">
                                    <h4 className="page-contact-section-title">Información Principal</h4>
                                    <div className="page-contact-grid">
                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Título<span className="page-contact-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese título"
                                                value={contact_title}
                                                onChange={(e) => setContactTitle(e.target.value)}
                                                required
                                            />
                                            <span className="page-contact-hint">Ingrese el título principal de la página de contacto</span>
                                        </div>

                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Sub Título<span className="page-contact-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese sub título"
                                                value={contact_sub_title}
                                                onChange={(e) => setContactSubTitle(e.target.value)}
                                                required
                                            />
                                            <span className="page-contact-hint">Ingrese el subtítulo de la página de contacto</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="page-contact-section">
                                    <h4 className="page-contact-section-title">Información de Contacto</h4>
                                    <div className="page-contact-grid">
                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Correo<span className="page-contact-required">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese correo"
                                                value={contact_email}
                                                onChange={(e) => setContactEmail(e.target.value)}
                                                required
                                            />
                                            <span className="page-contact-hint">Ingrese el correo electrónico de contacto</span>
                                        </div>

                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Teléfono<span className="page-contact-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese teléfono"
                                                value={contact_phone}
                                                onChange={(e) => setContactPhone(e.target.value)}
                                                required
                                            />
                                            <span className="page-contact-hint">Ingrese el número de teléfono de contacto</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="page-contact-section">
                                    <h4 className="page-contact-section-title">Factura</h4>
                                    <div className="page-contact-grid">
                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Card uno<span className="page-contact-required">*</span>
                                            </label>
                                            <textarea
                                                className="form-control form-control-sm page-contact-map-input"
                                                placeholder="..."
                                                value={card_1}
                                                onChange={(e) => setCard1(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Card dos<span className="page-contact-required">*</span>
                                            </label>
                                            <textarea
                                                className="form-control form-control-sm page-contact-map-input"
                                                placeholder="..."
                                                value={card_2}
                                                onChange={(e) => setCard2(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label className="page-contact-label">
                                                Link de facturación<span className="page-contact-required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                placeholder="Ingrese link de facturación"
                                                value={link_fact}
                                                onChange={(e) => setLinkFact(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="page-contact-section">
                                    <h4 className="page-contact-section-title">Ubicación</h4>
                                    <div className="form-group">
                                        <label className="page-contact-label">
                                            Dirección<span className="page-contact-required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese ubicación del contacto"
                                            value={contact_location}
                                            onChange={(e) => setContactLocation(e.target.value)}
                                            required
                                        />
                                        <span className="page-contact-hint">Ingrese la dirección física de contacto</span>
                                    </div>

                                    <div className="form-group">
                                        <label className="page-contact-label">
                                            Mapa<span className="page-contact-required">*</span>
                                        </label>
                                        <textarea
                                            className="form-control form-control-sm page-contact-map-input"
                                            placeholder="Ingrese url del mapa de contacto"
                                            value={contact_map}
                                            onChange={(e) => setContactMap(e.target.value)}
                                            required
                                        />
                                        <span className="page-contact-hint">Ingrese el código iframe del mapa de Google</span>
                                    </div>
                                </div>

                                <div className="page-contact-actions">
                                    <button type="submit" className="page-contact-btn page-contact-btn-primary">
                                        <i className="fa-regular fa-floppy-disk"></i>
                                        {page_contact_id === 0 ? "Guardar" : "Actualizar"}
                                    </button>
                                    <button
                                        onClick={handleClose}
                                        type="button"
                                        className="page-contact-btn page-contact-btn-secondary">
                                        <i className="fa-solid fa-ban"></i> Cancelar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PageContact;